import get from 'lodash.get'

export function normalizeFieldConfig (config) {
  if (!config) return null
  if (typeof config === 'string') return { accessor: config }
  return config
}

export function resolveFieldValue (row, fieldConfig) {
  if (!fieldConfig) return undefined
  const raw = get(row, fieldConfig.accessor)
  if (raw == null) return undefined
  const prefix = fieldConfig.prefix ? `${fieldConfig.prefix} ` : ''
  return `${prefix}${raw}`
}

export function findEdgeLabelConfig (edgeLabels, fromLevelId, toLevelId) {
  if (!Array.isArray(edgeLabels)) return null
  return edgeLabels.find(el => el.from === fromLevelId && el.to === toLevelId) || null
}

const NODE_TYPE_MAP = {
  card: 'flowGraphCard',
  banner: 'banner',
  pill: 'pill',
  circle: 'circle',
  diamond: 'diamond',
  metric: 'metric'
}

export function resolveNodeType (nodeType) {
  if (!nodeType) return 'flowGraphCard'
  return NODE_TYPE_MAP[nodeType] || 'flowGraphCard'
}
